/**
 * Провайдер друкованої форми — чий це документ: клієнта, перевізника чи
 * заявки (`SPEC-012` §4.3, `SPEC-025` §3.1.1).
 *
 * Копія беківського enum `Ship/Database/Enum/PrintableProvider.php`. Значення
 * звіряє вартовий В-6 (`Ship/Helpers/architectureGuard.test.ts`): новий
 * провайдер у беку без опції тут — падіння, а не сирий код у таблиці.
 *
 * Живе в Ship, бо його читають довідник «Типи документів» і меню генерації в
 * картках клієнта й перевізника (фаза 2). Порядок — порядок опцій select
 * (легасі `sorting` 10, 20, 30).
 */
export type PrintableProviderValue = 'client' | 'carrier' | 'application'

export interface PrintableProviderOption {
    value: PrintableProviderValue
    label: string
}

export const PRINTABLE_PROVIDER_OPTIONS: PrintableProviderOption[] = [
    { value: 'client', label: 'Клієнт' },
    { value: 'carrier', label: 'Перевізник' },
    { value: 'application', label: 'Заявка' },
]
